import {
    Box,
    Button,
    Center,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
    HStack,
    Text,
    Img,
    SimpleGrid,
} from '@chakra-ui/react';
import React from 'react';
import {atom, useRecoilState} from 'recoil';
import {LinkedinSvg, TwitterSvg} from '../../../assets';
import {COMPANIES} from '../../../constants/companies';

const selectedCompany = atom({
    key: 'selected-company__companies',
    default: null,
});

const PortfolioDetail = () => {
    const [companyDetail, setCompanyDetail] = useRecoilState(selectedCompany);

    const company = typeof companyDetail === 'number' ? COMPANIES[companyDetail] : null;

    return (
        <>
            <Drawer
                isOpen={typeof companyDetail === 'number'}
                placement="right"
                onClose={() => setCompanyDetail(null)}
                preserveScrollBarGap
            >
                <DrawerOverlay/>
                <DrawerContent maxW={['300px', '542px']} top={'19.2vh !important'}>
                    <DrawerCloseButton
                        bgColor={'brand.700'}
                        borderRadius={'full'}
                        color={'white'}
                        size={'lg'}
                        _focus={{
                            boxShadow: 'none',
                        }}
                        _active={{
                            backgroundColor: 'brand.700 !important',
                        }}
                        _hover={{
                            backgroundColor: 'brand.700 !important',
                        }}
                        sx={{
                            left: '-20px',
                            top: '-20px',
                        }}
                    />
                    <DrawerHeader minH={'180px'} as={Center}>
                        <Img
                            userSelect={'none'}
                            maxHeight={'140px'}
                            alt={'profile-avatar'}
                            src={company?.company_logo}
                        />
                    </DrawerHeader>

                    <DrawerBody
                        bgColor={'#F9F9F9'}
                        pb={['3.5', '0 !important']}
                        p={['40px', '60px']}
                        display={'flex'}
                        flexDirection={'column'}
                    >
                        <Text
                            fontSize={['1.125rem', '2rem']}
                            mb={'60px'}
                            lineHeight={'38.4px'}
                            letterSpacing={'-1px'}
                            minH={'152px'}
                            overflow='scroll'
                        >
                            {company?.long_description}
                        </Text>
                        <Box mb={'40px'}>
                            <SimpleGrid columns={2} spacing={[6, 8]}>
                                {company?.sector && (
                                    <Box>
                                        <Text
                                            fontSize={'xs'}
                                            lineHeight={'10.4px'}
                                            fontWeight={'semibold'}
                                            textTransform={'uppercase'}
                                            textColor={'brand.700'}
                                        >
                                            Sector
                                        </Text>
                                        <Text
                                            fontSize={'md'}
                                            lineHeight={'6'}
                                            textTransform={'capitalize'}
                                            textColor={'black'}
                                        >
                                            {company?.sector}
                                        </Text>
                                    </Box>
                                )}
                                {company?.investment_status?.[0].name && (
                                    <Box>
                                        <Text
                                            fontSize={'xs'}
                                            lineHeight={'10.4px'}
                                            fontWeight={'semibold'}
                                            textTransform={'uppercase'}
                                            textColor={'brand.700'}
                                        >
                                            company status
                                        </Text>
                                        <Text
                                            fontSize={'md'}
                                            lineHeight={'6'}
                                            textTransform={'capitalize'}
                                            textColor={'black'}
                                        >
                                            {company?.investment_status?.[0].name}
                                        </Text>
                                    </Box>
                                )}
                                {company?.first_funded_round && (
                                    <Box>
                                        <Text
                                            fontSize={'xs'}
                                            lineHeight={'10.4px'}
                                            fontWeight={'semibold'}
                                            textTransform={'uppercase'}
                                            textColor={'brand.700'}
                                        >
                                            First Investment
                                        </Text>
                                        <Text
                                            fontSize={'md'}
                                            lineHeight={'6'}
                                            textTransform={'capitalize'}
                                            textColor={'black'}
                                        >
                                            {company?.first_funded_round}
                                        </Text>
                                    </Box>
                                )}
                                {company?.first_funded_year && (
                                    <Box>
                                        <Text
                                            fontSize={'xs'}
                                            lineHeight={'10.4px'}
                                            fontWeight={'semibold'}
                                            textTransform={'uppercase'}
                                            textColor={'brand.700'}
                                        >
                                            year funded
                                        </Text>
                                        <Text
                                            fontSize={'md'}
                                            lineHeight={'6'}
                                            textTransform={'capitalize'}
                                            textColor={'black'}
                                        >
                                            {company?.first_funded_year}
                                        </Text>
                                    </Box>
                                )}
                                {company?.venrock_partners?.[0]?.name && (
                                    <Box>
                                        <Text
                                            fontSize={'xs'}
                                            lineHeight={'10.4px'}
                                            fontWeight={'semibold'}
                                            textTransform={'uppercase'}
                                            textColor={'brand.700'}
                                        >
                                            venrock team
                                        </Text>
                                        <Text
                                            fontSize={'md'}
                                            lineHeight={'6'}
                                            textTransform={'capitalize'}
                                            textColor={'black'}
                                        >
                                            {company?.venrock_partners?.[0]?.name}{' '}
                                        </Text>
                                    </Box>
                                )}
                            </SimpleGrid>
                        </Box>
                        <HStack mt={'auto'} mb={'1rem'}>
                            {company?.website_url && (
                                <Button
                                    mr={'10px'}
                                    size={'lg'}
                                    isActive
                                    onClick={() => window.open(company?.website_url, '_blank')}
                                    noOfLines={1}
                                >
                                    {company?.website_url
                                        .split('/')
                                        .slice(2, 3)
                                        .join('')
                                        .replace('www.', '')}
                                </Button>
                            )}
                            <HStack spacing={2}>
                                {company?.twitter_url && (
                                    <Button
                                        size={'xs'}
                                        variant={'solid'}
                                        bgColor={'transparent'}
                                        iconSpacing={0}
                                        borderRadius={'full'}
                                        onClick={() => window.open(company?.twitter_url, '_blank')}
                                    >
                                        <TwitterSvg/>
                                    </Button>
                                )}
                                {company?.linkedin_url && (
                                    <Button
                                        size={'xs'}
                                        variant={'solid'}
                                        bgColor={'transparent'}
                                        iconSpacing={0}
                                        borderRadius={'full'}
                                        onClick={() => window.open(company?.linkedin_url, '_blank')}
                                    >
                                        <LinkedinSvg/>
                                    </Button>
                                )}
                            </HStack>
                        </HStack>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>
    );
};
export default PortfolioDetail;
export {selectedCompany};
